// extracted by mini-css-extract-plugin
module.exports = {"root":"amount_root__OlKNq"};